/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {EmptyableConfig} from "./EmptyableConfig";
import {UiSplitDirection} from "./UiSplitDirection";
import {UiSplitSizePolicy} from "./UiSplitSizePolicy";


export interface UiSplitPaneConfig extends UiComponentConfig, EmptyableConfig {
	_type?: string;
	splitDirection: UiSplitDirection;
	sizePolicy: UiSplitSizePolicy;
	referenceChildSize?: number;
	firstChild?: UiComponentConfig;
	lastChild?: UiComponentConfig;
	firstChildMinSize?: number;
	lastChildMinSize?: number;
	resizable?: boolean;
	fillIfSingleChild?: boolean;
	collapseEmptyChildren?: boolean
}

export interface UiSplitPaneCommandHandler {
	setFirstChild(firstChild: UiComponentConfig): void;
	setLastChild(lastChild: UiComponentConfig): void;
	setSize(referenceChildSize: number, sizePolicy: UiSplitSizePolicy): void;
}

export interface UiSplitPaneEventSource {
	onResized: TeamAppsEvent<UiSplitPane_ResizedEvent>;
}

export interface UiSplitPane_ResizedEvent extends UiEvent {
	_type: "UiSplitPane.resized";
	redundancyKey?: string;
	referenceChildSize: number
}

